export default "__VITE_ASSET__DfTiOMMC__"